import { CompositeDecorator, ContentState, convertFromRaw, Editor, EditorState } from 'draft-js';
import { useEffect, useState } from 'react';
import styled from 'styled-components';

interface ReadOnlyEditorProps {
    storedStateRaw: any;
}

const ReadOnlyEditorContainer = styled.div`
  h1,h2,h3,h4,h5,h6,span {
    letter-spacing: normal !important;
  }  

a > * {
    color: inherit;
    text-decoration: none;
    font-weight: bold;
    color: #0066cc;
    text-decoration: underline;
  }

`;

export const ReadOnlyEditor = ({ storedStateRaw }: ReadOnlyEditorProps) => {

    const decorator = new CompositeDecorator([
        {
            strategy: findLinkEntities,
            component: Link,
        },
    ]);

    const initalizeEditorState = () => {
        if ((storedStateRaw != null && storedStateRaw.length > 0)) {
            if (isJsonString(storedStateRaw)) {
                return EditorState.createWithContent(convertFromRaw(JSON.parse(storedStateRaw)), decorator);
            } else {
                return EditorState.createWithContent(ContentState.createFromText(storedStateRaw));
            }
        }
        return EditorState.createEmpty();
    }

    const isJsonString = (str) => {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }

    const [editorState, setEditorContent] = useState(initalizeEditorState())

    useEffect(() => {
        setEditorContent(initalizeEditorState())
    }, [storedStateRaw])

    if (storedStateRaw == null) return <></>

    return (
        <ReadOnlyEditorContainer className="readonly-editor">
            <Editor editorKey="editor" editorState={editorState} readOnly={true} onChange={() => { }} />
        </ReadOnlyEditorContainer>
    );
}


const findLinkEntities = (contentBlock, callback, contentState) => {
    contentBlock.findEntityRanges(
        (character) => {
            const entityKey = character.getEntity();
            return (
                entityKey !== null &&
                contentState.getEntity(entityKey).getType() === 'LINK'
            );
        },
        callback
    );
}

const Link = (props) => {
    const { url, targetOption } = props.contentState.getEntity(props.entityKey).getData();
    return (
        targetOption != null && targetOption.length > 0 ?
            <a href={url} target={targetOption} >
                {props.children}
            </a>
            :
            <a href={url} >
                {props.children}
            </a>
    );
};
